import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FiltratedObjetives, Objetive } from '../../../../api/interfaces/register';
import {DateAdapter} from '@angular/material/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
import { MobileDetectorService } from '../../../../services/mobileDetector/mobile-detector.service';
import { SharedDataService } from 'src/app/services/sharedData/shared-data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-inputs',
  templateUrl: './inputs.component.html',
  styleUrls: ['./inputs.component.scss']
})
export class InputsComponent implements OnInit {

  isMobile: boolean = false;
  isRegistration: boolean = false;
  activo: boolean = true;
  minDate: Date = new Date();
  objetivesForm = new FormGroup({
    name: new FormControl(),
    date: new FormControl(),
    i: new FormControl(),
    id: new FormControl(),
  });

  selected: Date;

  @Output() removeObjetiveEvent = new EventEmitter<any>();
  @Output() saveObjetiveEvent: EventEmitter<any> = new EventEmitter();
  
  @Input('i') i?: number;
  @Input('disable') disable?: boolean;
  @Input('objetive') objetive? : FiltratedObjetives;

  constructor(
    private _adapter: DateAdapter<any>,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private mobileDetectorService: MobileDetectorService,
    private sharedData: SharedDataService,
    private router: ActivatedRoute,
  ) {
    this.matIconRegistry.addSvgIcon(
      `delete`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../../../../assets/delete.svg')
    );
   }

   ngOnInit(): void {
    this.objetivesForm.value.i = this.i;
    const url = this.router.snapshot.routeConfig.path;
    if(url == "registration") {
      this.isRegistration = true;
    }
    this.sharedData.currentMessage.subscribe(message => {
      if(message =="editObjetives") {
        this.objetivesForm.controls['name'].enable();
        this.objetivesForm.controls['date'].enable();
      }
    });
    this.isMobile = this.mobileDetectorService.isMobile();
    this.addObjetive();
    this._adapter.setLocale('es');
    if(this.objetive) {
      this.objetivesForm.patchValue({name: this.objetive.objetivoDescripcion});
      this.objetivesForm.patchValue({date: this.objetive.fechaObjetivo});
      this.objetivesForm.patchValue({id: this.objetive.id});
      if(this.objetive.id_objetive) {
        this.i = this.objetive.id_objetive;
      }
      if(this.isRegistration) {
        this.i = this.objetive.id_objetive;
      }
    } else {
      this.objetivesForm.patchValue({id: null});  //requerido por backend
    }
    if(this.disable) {
      this.objetivesForm.controls['name'].disable();
      this.objetivesForm.controls['date'].disable();
    }

    this.sharedData.currentMessage.subscribe(message => {
      if(message == "remove" && this.objetive.activo != undefined) {
        this.activo = this.objetive.activo;
      }
    });


  }

  removeObjetive() {
    if(!this.disable) {
      this.removeObjetiveEvent.emit(this.i);
    }
  }

  addObjetive() {
    if(this.i && !this.isRegistration) {
      this.objetivesForm.value.i = this.i;
    }
    if(this.isRegistration || !this.objetivesForm.value.i) {
      this.objetivesForm.value.i = this.i;
    }
    if(this.objetivesForm.value.date) {
      let auxDate = this.objetivesForm.value.date;
      if(auxDate._d) {
        auxDate._d.setHours(12);
      }
    }
    this.saveObjetiveEvent.emit(this.objetivesForm.value);
  }

}